import React from 'react'
import { blue } from "@material-ui/core/colors";
import RegularButton from "components/CustomButtons/Button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Edit from "@material-ui/icons/Edit";

const configTable = [
  {
    Header: "Marca",
    accessor: "brandName",
    filterable: true,
    filterMethod: (filter, row) =>
      row.brandName.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Celular",
    accessor: "cellphone",
    filterable: true,
    filterMethod: (filter, row) =>
      row.cellphone.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "WhatsApp",
    accessor: "whatsapp",
    filterable: true,
    filterMethod: (filter, row) =>
      row.whatsapp.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Url",
    accessor: "url",
    filterable: true,
    filterMethod: (filter, row) =>
      row.url.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Planta",
    accessor: "stationName",
  },
  {
    Header: "Acciones",
    accessor: "id",
    sortable: false,
    filterable: false,
    Cell: ({original}) => {
      const hist = useHistory()
      const handleChangePage = (page) => {
        const newDirection = page ? page : "/admin/nuevo_marca";
        hist.push(newDirection);
      };
      return (
      <div className="actions-right">
          <RegularButton
            justIcon
            round
            color="transparent"
            tooltip="Editar"
            onClick={() =>
              handleChangePage(`/admin/editar_marca_venta/editar/${original?.id}`)
            }

          >
            <Edit style={{color: blue[800]}}/>
          </RegularButton>
      </div>
    )},
  }
];

export { configTable };
